import secureLocalStorage from "react-secure-storage";

export function readStored(key) {
  try {
    return secureLocalStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

export function readStoredObject(key) {
  const value = readStored(key);
  if (!value) return null;
  if (typeof value === "object") return value;
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}
